module.exports = __webpack_public_path__ + "media/images/logo-rema-972fbfafeffa3b2b8f805adf36441ce7.svg";